// extracted by mini-css-extract-plugin
export default {"wrapper":"AJsbA__wrapper","header":"sJw9M__header","reason":"iDhpW__reason"};